import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _getActivePlans = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/plans`,
    });
};

export const _getActiveUsersByPlan = (planId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/plans/${planId}/active-users`,
    });
};

export const _getFreeUsersByPlan = (planId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/plans/${planId}/free-users`,
    });
};


// WEBPACK FOOTER //
// ./src/services/apis/PlanAPI.js